'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _click_or_escape_outside = require('./click_or_escape_outside.js');

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _button = require('./global_components/button.js');

var _button2 = _interopRequireDefault(_button);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _dropdown_component = require('./global_components/dropdown_component.js');

var _dropdown_component2 = _interopRequireDefault(_dropdown_component);

var _table_component = require('./global_components/table_component.js');

var _table_component2 = _interopRequireDefault(_table_component);

var _pagination_input = require('./pagination_input.js');

var _pagination_input2 = _interopRequireDefault(_pagination_input);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _readable_field_component = require('./global_components/readable_field_component');

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _accessibility_utility = require('../../../packages/common-utilities/src/accessibility_utility');

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var HoldingsCard = function (_Component) {
  _inherits(HoldingsCard, _Component);

  function HoldingsCard(props) {
    _classCallCheck(this, HoldingsCard);

    var _this = _possibleConstructorReturn(this, (HoldingsCard.__proto__ || Object.getPrototypeOf(HoldingsCard)).call(this, props));

    _this.setPaginationInputFocus = function () {
      _this.child.setFocusFromParent();
    };

    _this.onClose = _this.onClose.bind(_this);
    _this.onCloseRowDrop = _this.onCloseRowDrop.bind(_this);

    var orderedData = [];

    if (!(0, _functional_utility.isNilOrEmpty)(_this.props.data)) {
      var listData = _this.props.showWeeklyHoldings ? _this.props.data.data : _this.props.data.holdings;
      orderedData = listData;
      if (!(0, _ramda.isNil)(listData) && !(0, _ramda.isNil)(_this.props.data.sortOrder) && !(0, _ramda.isNil)(_this.props.data.defaultSortCriteria)) {
        if (_this.props.data.sortOrder === 'desc') {
          orderedData = (0, _ramda.sortWith)([(0, _ramda.descend)((0, _ramda.prop)(_this.props.data.defaultSortCriteria))])(listData);
        } else {
          orderedData = (0, _ramda.sortWith)([(0, _ramda.ascend)((0, _ramda.prop)(_this.props.data.defaultSortCriteria))])(listData);
        }
      }
    }

    _this.state = {
      data: orderedData,
      currentPage: 1,
      currentPageDisplay: 1,
      itemsPerPage: 10,
      selectedRowValue: _this.props.intl.formatMessage({ id: "pdp-holdings-view-10-label", defaultMessage: "View 10" }),
      sortOrderAsc: !(0, _functional_utility.isNilOrEmpty)(_this.props.data) ? _this.props.data.sortOrder === 'asc' : false,
      sortBy: !(0, _functional_utility.isNilOrEmpty)(_this.props.data) ? _this.props.data.defaultSortCriteria : null
    };

    _this.prevPage = _this.prevPage.bind(_this);
    _this.nextPage = _this.nextPage.bind(_this);
    _this.setPaginationInputFocus = _this.setPaginationInputFocus.bind(_this);
    _this.changeItemsPerPage = _this.changeItemsPerPage.bind(_this);
    _this.changeDateFilter = _this.changeDateFilter.bind(_this);
    _this.changeSortFilter = _this.changeSortFilter.bind(_this);
    _this.setCurrentPageDisplay = _this.setCurrentPageDisplay.bind(_this);
    _this.updateCurrentPage = function (pageNo) {
      _this.setCurrentPageDisplay(pageNo);
    };
    return _this;
  }

  _createClass(HoldingsCard, [{
    key: 'onClose',
    value: function onClose() {
      this.childRef.focus();
    }
  }, {
    key: 'onCloseRowDrop',
    value: function onCloseRowDrop() {
      this.childRefRowDrop.focus();
    }
  }, {
    key: 'displayRowLabels',
    value: function displayRowLabels() {
      var _this2 = this;

      var items = [];
      var options = [{
        value: "view-10",
        displayValue: this.props.intl.formatMessage({ id: "pdp-holdings-view-10-label", defaultMessage: "View 10" })
      }, {
        value: "view-20",
        displayValue: this.props.intl.formatMessage({ id: "pdp-holdings-view-20-label", defaultMessage: "View 20" })
      }, {
        value: "view-50",
        displayValue: this.props.intl.formatMessage({ id: "pdp-holdings-view-50-label", defaultMessage: "View 50" })
      }];
      mapIndexed(function (option, index) {
        _this2[option.value + 'displayRowsDropdown'] = _react2.default.createRef();
        var isLastElement = options.length - 1 === index;
        items.push(_react2.default.createElement(
          'div',
          { key: index, 'data-option-value': option.value, 'data-display-value': option.displayValue,
            onClick: _this2.changeItemsPerPage,
            ref: _this2[option.value + 'displayRowsDropdown'],
            onKeyDown: function onKeyDown(event) {
              return _accessibility_utility2.default.handleDropdownEvents(_this2, event, '#display-row-selector', option.value + 'displayRowsDropdown', 'view-10displayRowsDropdown', isLastElement, function () {
                return _this2.changeItemsPerPage(event);
              });
            },
            tabIndex: 0, className: 'dropdown-list-item', role: 'option' },
          _react2.default.createElement(
            'span',
            { className: 'font-light caption', 'data-option-value': option.value,
              'data-display-value': option.displayValue },
            option.displayValue
          )
        ));
      }, options);
      return items;
    }
  }, {
    key: 'getReportDates',
    value: function getReportDates() {
      var _this3 = this;

      var items = [];
      var options = this.props.showWeeklyHoldings ? [this.props.data.effectiveDate] : this.props.data.dates;
      mapIndexed(function (date, index) {
        var isLastElement = options.length - 1 === index;
        _this3[date + 'reportDatesDropdown'] = _react2.default.createRef();
        items.push(_react2.default.createElement(
          'div',
          { key: index, 'data-option-value': _string_utility2.default.customKebabCase(date), 'data-display-value': _this3.getFormattedDateWithoutTimezone(date),
            onClick: _this3.changeDateFilter,
            tabIndex: 0,
            ref: _this3[date + 'reportDatesDropdown'],
            onKeyDown: function onKeyDown(event) {
              return _accessibility_utility2.default.handleDropdownEvents(_this3, event, '#report-date-selector', date + 'reportDatesDropdown', date[0] + 'reportDatesDropdown', isLastElement, function () {
                return _this3.changeDateFilter(event);
              });
            },
            className: 'dropdown-list-item', role: 'option' },
          _react2.default.createElement(
            'span',
            { className: 'font-light caption', 'data-option-value': _string_utility2.default.customKebabCase(date),
              'data-display-value': _this3.getFormattedDateWithoutTimezone(date) },
            _this3.getFormattedDateWithoutTimezone(date)
          )
        ));
      }, options);

      return items;
    }
  }, {
    key: 'setCurrentPageDisplay',
    value: function setCurrentPageDisplay(pageNo) {
      if (pageNo !== "") {
        this.setState({ currentPage: Number(pageNo), currentPageDisplay: Number(pageNo) });
      } else {
        this.setState({ currentPageDisplay: "" });
      }
      this.props.cardDataChanged();
    }
  }, {
    key: 'getFilteredData',
    value: function getFilteredData() {
      var navDateToFilterBy = this.props.showWeeklyHoldings ? this.getDateToFilterBy() : (0, _moment2.default)(this.getDateToFilterBy(), "MM-DD-YYYY").format('YYYY-MM-DD');
      return (this.state.data || []).filter(function (holding) {
        return holding.navDate === navDateToFilterBy;
      });
    }
  }, {
    key: 'renderHoldingsDataRows',
    value: function renderHoldingsDataRows() {
      var _this4 = this;

      if ((0, _ramda.isNil)(this.state.data)) {
        return null;
      }
      var _state = this.state,
          currentPage = _state.currentPage,
          itemsPerPage = _state.itemsPerPage;

      var indexOfLastItem = currentPage * itemsPerPage;
      var indexOfFirstItem = indexOfLastItem - itemsPerPage;
      var currentItems = this.getFilteredData().slice(indexOfFirstItem, indexOfLastItem);
      var visibleDataPoints = this.props.visibleDataPoints || [];
      return mapIndexed(function (holdingsData, i) {
        return _react2.default.createElement(
          'tr',
          { key: i, className: 'padding-vertical-5 category row-divider',
            'data-testid': 'portfolio-all-holdings-row' },
          !(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_INVESTMENT_CATEGORY_COLUMN", visibleDataPoints) ? _react2.default.createElement(
            'td',
            { className: 'margin-top-5', 'data-testid': 'performance-tab-data-security-type-label' },
            holdingsData.securityType
          ) : null,
          _react2.default.createElement(
            'td',
            { className: 'margin-top-5', 'data-testid': 'performance-tab-data-security-description-label' },
            holdingsData.securityDescription
          ),
          _react2.default.createElement(
            'td',
            { className: 'margin-top-5', 'data-testid': 'performance-tab-data-security-id-label' },
            holdingsData.securityId
          ),
          _react2.default.createElement(
            'td',
            { className: 'margin-top-5', 'data-testid': 'performance-tab-data-wam-maturity-date-label' },
            _this4.getFormattedDate(holdingsData.wamMaturityDate)
          ),
          !(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_FINAL_LEGAL_MATURITY_COLUMN", visibleDataPoints) ? _react2.default.createElement(
            'td',
            { className: 'margin-top-5', 'data-testid': 'performance-tab-data-final-legal-maturity-date-label' },
            _this4.getFormattedDate(holdingsData.finalLegalMaturityDate)
          ) : null,
          !(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_COUPON_OR_YIELD_COLUMN", visibleDataPoints) ? _react2.default.createElement(
            'td',
            { className: 'margin-top-5', 'data-testid': 'performance-tab-data-yield-label' },
            _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToAmount(holdingsData.securityYield, 2), numberFormat: _this4.props.numberFormat })
          ) : null,
          _react2.default.createElement(
            'td',
            { className: 'margin-top-5', 'data-testid': 'performance-tab-data-principal-amount-label' },
            _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(holdingsData.liquidationFaceValue, 2)), numberFormat: _this4.props.numberFormat })
          ),
          _react2.default.createElement(
            'td',
            { className: 'margin-top-5', 'data-testid': 'performance-tab-data-base-market-value-label' },
            _react2.default.createElement(_formatted_number2.default, { value: _number_utility2.default.convertToNumberWithCommas(_number_utility2.default.convertToAmount(holdingsData.marketValue, 2)), numberFormat: _this4.props.numberFormat })
          )
        );
      }, currentItems);
    }
  }, {
    key: 'getFormattedDate',
    value: function getFormattedDate(date) {
      if ((0, _functional_utility.isNilOrEmpty)(date)) {
        return "-";
      }
      return _date_formatter2.default.getLocalFormattedDateForInjectIntl(date, this.props.intl);
    }
  }, {
    key: 'getFormattedDateWithoutTimezone',
    value: function getFormattedDateWithoutTimezone(date) {
      if ((0, _functional_utility.isNilOrEmpty)(date)) {
        return "-";
      }
      return _date_formatter2.default.getLocalFormattedDateForInjectIntl(date, this.props.intl, false);
    }
  }, {
    key: 'renderHeaderRow',
    value: function renderHeaderRow(labels) {
      var _this5 = this;

      var visibleDataPoints = this.props.visibleDataPoints || [];
      var columns = [];
      if (!(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_INVESTMENT_CATEGORY_COLUMN", visibleDataPoints)) {
        columns.push("securityType");
      }
      columns.push("securityDescription");
      columns.push("securityId");
      columns.push("wamMaturityDate");
      if (!(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_FINAL_LEGAL_MATURITY_COLUMN", visibleDataPoints)) {
        columns.push("finalLegalMaturityDate");
      }
      if (!(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_COUPON_OR_YIELD_COLUMN", visibleDataPoints)) {
        columns.push("securityYield");
      }
      columns.push("liquidationFaceValue");
      columns.push("marketValue");

      var row = [];
      _collection_utility.CollectionUtility.forEachIndexed(labels, function (value, i) {
        var sortIndicator = "ct-icon ct-icon-caret-down large-sorter";
        var sortLabel = "none";
        var columnActive = "";
        if (columns[i] === _this5.state.sortBy) {
          columnActive = 'font-teal';
          sortIndicator = "ct-icon ct-icon-caret-down font-teal active large-sorter";
          sortLabel = "ascending";
          if (!_this5.state.sortOrderAsc) {
            sortIndicator = "ct-icon ct-icon-caret-up font-teal active large-sorter";
            sortLabel = "descending";
          }
        }
        row.push(_react2.default.createElement(
          'th',
          { key: i, style: { "verticalAlign": "middle" }, 'aria-sort': sortLabel },
          _react2.default.createElement(
            'div',
            { tabIndex: 0, role: 'button',
              onClick: _this5.changeSortFilter,
              onKeyPress: function onKeyPress(event) {
                _accessibility_utility2.default.handleSpaceOrEnterClick(_this5, event, _this5.changeSortFilter.bind(_this5, event));
              },
              'data-column': columns[i], 'data-testid': columns[i] + '-label', key: value, className: 'display-flex curs align-items-center tag cursor-pointer ' + columnActive },
            _react2.default.createElement(
              'span',
              { 'data-testid': columns[i] + '-value', 'data-column': columns[i], className: "white-space-pre" },
              value
            ),
            _react2.default.createElement('span', { 'data-testid': columns[i] + '-icon', 'data-column': columns[i], className: sortIndicator })
          )
        ));
      });

      return row;
    }
  }, {
    key: 'prevPage',
    value: function prevPage() {
      var prevPage = this.state.currentPage - 1;
      if (prevPage < 1) {
        prevPage = 1;
      } else if (prevPage === 1) {
        this.setPaginationInputFocus();
      }

      this.setCurrentPageDisplay(prevPage);
    }
  }, {
    key: 'nextPage',
    value: function nextPage() {
      var _state2 = this.state,
          currentPage = _state2.currentPage,
          itemsPerPage = _state2.itemsPerPage;

      var totalPages = Math.ceil(this.getFilteredData().length === 0 ? 1 : this.getFilteredData().length / itemsPerPage);
      var nextPage = currentPage + 1;

      if (nextPage > totalPages) {
        nextPage = totalPages;
      } else if (nextPage === totalPages) {
        this.setPaginationInputFocus();
      }

      this.setCurrentPageDisplay(nextPage);
    }
  }, {
    key: 'changeItemsPerPage',
    value: function changeItemsPerPage(event) {
      var selectedRowValue = event.target.getAttribute("data-option-value") || "view-10";
      var selectedRowDisplayValue = event.target.getAttribute("data-display-value") || "View 10";
      var selectedCount = selectedRowValue.replace("view-", "");
      this.setState({
        itemsPerPage: Number(selectedCount),
        selectedRowValue: selectedRowDisplayValue,
        currentPage: 1,
        currentPageDisplay: 1
      });
      this.setCurrentPageDisplay(1);
    }
  }, {
    key: 'changeDateFilter',
    value: function changeDateFilter(event) {
      this.setState({
        dateToFilterBy: event.target.getAttribute("data-option-value"),
        dateToFilterByDisplayValue: event.target.getAttribute("data-display-value")
      });
      this.setCurrentPageDisplay(1);
    }
  }, {
    key: 'changeSortFilter',
    value: function changeSortFilter(event) {
      var sortOrderAsc = true;
      var targetColumn = event.target.getAttribute("data-column");

      var sortedHoldings = (0, _ramda.sortBy)((0, _ramda.prop)(targetColumn))(this.props.showWeeklyHoldings ? this.props.data.data : this.props.data.holdings);

      if (targetColumn === this.state.sortBy) {
        sortOrderAsc = !this.state.sortOrderAsc;
        if (!sortOrderAsc) {
          sortedHoldings = sortedHoldings.reverse();
        }
      }
      this.setState({
        data: sortedHoldings,
        sortBy: targetColumn,
        sortOrderAsc: sortOrderAsc
      });
      this.setCurrentPageDisplay(1);
    }
  }, {
    key: 'getDateToFilterBy',
    value: function getDateToFilterBy() {
      return this.state.dateToFilterBy || _string_utility2.default.customKebabCase(this.props.showWeeklyHoldings ? this.props.data.effectiveDate : this.props.data.dates[0]);
    }
  }, {
    key: 'getDefaultDateToFilterBy',
    value: function getDefaultDateToFilterBy() {
      if (this.state.dateToFilterByDisplayValue) {
        return this.getFormattedDateWithoutTimezone(this.state.dateToFilterByDisplayValue);
      }

      return this.props.showWeeklyHoldings ? this.getFormattedDate(this.props.data.effectiveDate) : this.getFormattedDateWithoutTimezone(this.props.data.dates[0]);
    }
  }, {
    key: 'displayPagination',
    value: function displayPagination(currentPageDisplay, totalNumberOfPages) {
      var _this6 = this;

      var leftArrowStyling = currentPageDisplay === 1 ? "display-none" : "font-super-black";
      var rightArrowStyling = currentPageDisplay === totalNumberOfPages ? "display-none" : "font-super-black";

      if (totalNumberOfPages <= 1) {
        return null;
      } else {
        return _react2.default.createElement(
          'div',
          {
            className: '' + (this.props.breakpoint < 2 ? "col-xs-12 col-sm-12 text-center padding-vertical-20" : "text-right margin-top-30 float-right"),
            'data-testid': 'portfolio-all-holdings-pagination' },
          _react2.default.createElement(
            'a',
            { className: 'text-decoration-none-important border-all-1 border-super-black border-radius-50 padding-horizontal-2 padding-bottom-3 ' + leftArrowStyling,
              tabIndex: 0,
              onClick: this.prevPage,
              onKeyDown: function onKeyDown(event) {
                return _accessibility_utility2.default.handleEnterClick(_this6, event, _this6.prevPage);
              },
              'data-testid': 'portfolio-all-holdings-left-chevron', 'aria-label': "Previous page" },
            _react2.default.createElement('span', { className: 'icon-leftchevron' })
          ),
          _react2.default.createElement(_pagination_input2.default, { initialPageNumber: currentPageDisplay, onChange: this.updateCurrentPage,
            ref: function ref(c) {
              return _this6.child = c;
            }
          }),
          _react2.default.createElement(
            'span',
            { 'data-testid': 'portfolio-all-holdings-total-pages',
              className: 'margin-right-10 tag' },
            '/ ',
            totalNumberOfPages
          ),
          _react2.default.createElement(
            'a',
            { className: 'text-decoration-none-important border-all-1 border-super-black border-radius-50 padding-horizontal-2 padding-bottom-3 ' + rightArrowStyling,
              tabIndex: currentPageDisplay === totalNumberOfPages ? -1 : 0,
              onClick: this.nextPage,
              onKeyDown: function onKeyDown(event) {
                return _accessibility_utility2.default.handleEnterClick(_this6, event, _this6.nextPage);
              },
              'data-testid': 'portfolio-all-holdings-right-chevron', 'aria-label': "Next page" },
            _react2.default.createElement('span', { className: 'icon-rightchevron' })
          )
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      if ((0, _ramda.isNil)(this.props.data)) {
        return null;
      }
      var itemsPerPage = this.state.itemsPerPage;

      var selectedRowValue = this.state.selectedRowValue;
      var totalNumberOfPages = Math.ceil(this.getFilteredData().length / itemsPerPage);
      var visibleDataPoints = this.props.visibleDataPoints || [];

      var labels = [];
      if (!(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_INVESTMENT_CATEGORY_COLUMN", visibleDataPoints)) {
        labels.push(this.props.intl.formatMessage({ defaultMessage: 'Investment\nCategory', id: 'pdp-portfolio-holdings-investment-category' }));
      }
      labels.push(this.props.intl.formatMessage({ defaultMessage: 'Issuer', id: 'pdp-portfolio-holdings-issuer' }));
      labels.push(this.props.intl.formatMessage({ defaultMessage: 'CUSIP', id: 'pdp-portfolio-holdings-identifier' }));
      labels.push(this.props.intl.formatMessage({ defaultMessage: 'Effective\nMaturity', id: 'pdp-portfolio-holdings-effective-maturity' }));
      if (!(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_FINAL_LEGAL_MATURITY_COLUMN", visibleDataPoints)) {
        labels.push(this.props.intl.formatMessage({ defaultMessage: 'Final Legal\nMaturity', id: 'pdp-portfolio-holdings-final-legal-maturity' }));
      }
      if (!(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_COUPON_OR_YIELD_COLUMN", visibleDataPoints)) {
        labels.push(this.props.intl.formatMessage({ defaultMessage: 'Coupon or\nYield (%)', id: 'pdp-portfolio-holdings-coupon-or-yield' }));
      }
      if ((0, _ramda.includes)("SHOW_PRINCIPAL_AMOUNT_UNITS_FOR_ALL_HOLDINGS_TABLE", visibleDataPoints)) {
        labels.push(this.props.intl.formatMessage({ defaultMessage: 'Principal\nAmount', id: 'pdp-portfolio-holdings-principal-amount-units' }));
      } else {
        labels.push(this.props.intl.formatMessage({ defaultMessage: 'Principal\nAmount', id: 'pdp-portfolio-holdings-principal-amount' }) + ' (' + _currency_utility2.default.getCurrencyMapping(this.props.currencyCode, this.props.country).trim() + ')');
      }
      labels.push(this.props.intl.formatMessage({ defaultMessage: 'Market\nValue', id: 'pdp-portfolio-holdings-base-market-value' }) + ' (' + _currency_utility2.default.getCurrencyMapping(this.props.currencyCode, this.props.country).trim() + ')');

      var excelLabels = [];
      if (!(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_FIXED_VARIABLE_COLUMN", visibleDataPoints)) {
        excelLabels.push(this.props.intl.formatMessage({ defaultMessage: 'Fixed/Variable', id: 'pdp-portfolio-holdings-fixed-variable' }));
      }
      if (!(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_PARENT_NAME_COLUMN", visibleDataPoints)) {
        excelLabels.push(this.props.intl.formatMessage({ defaultMessage: 'Parent Name', id: 'pdp-portfolio-holdings-parent-name' }));
      }
      excelLabels.push(this.props.intl.formatMessage({ defaultMessage: '% of Total Value', id: 'pdp-portfolio-holdings-total-value' }));
      if (!(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_S_AND_P_COLUMN", visibleDataPoints)) {
        excelLabels.push(this.props.intl.formatMessage({
          defaultMessage: 'S and P Rating',
          id: 'pdp-portfolio-holdings-sp-rating'
        }));
      }
      if (!(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_MOODYS_RATINGS_COLUMN", visibleDataPoints)) {
        excelLabels.push(this.props.intl.formatMessage({
          defaultMessage: 'Moodys Rating',
          id: 'pdp-portfolio-holdings-moodys-rating'
        }));
      }
      if (!(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_FITCH_RATING_COLUMN", visibleDataPoints)) {
        excelLabels.push(this.props.intl.formatMessage({
          defaultMessage: 'Fitch Rating',
          id: 'pdp-portfolio-holdings-fitch-rating'
        }));
      }
      if (!(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_COUNTRY_COLUMN", visibleDataPoints)) {
        excelLabels.push(this.props.intl.formatMessage({ defaultMessage: 'Country', id: 'pdp-portfolio-holdings-country' }));
      }
      if (!(0, _ramda.includes)("HIDE_ALL_HOLDINGS_TABLE_SPONSOR_COLUMN", visibleDataPoints)) {
        excelLabels.push(this.props.intl.formatMessage({ defaultMessage: 'Sponsor', id: 'pdp-portfolio-holdings-sponsor' }));
      }

      var labelsForExcel = labels.concat(excelLabels);

      var creditRatingCount = _collection_utility.CollectionUtility.filter(this.getFilteredData(), function (o) {
        return !(0, _ramda.isNil)(o.internalCreditRating);
      });

      if (!(0, _functional_utility.isNilOrEmpty)(creditRatingCount)) {
        labelsForExcel = labelsForExcel.concat([this.props.intl.formatMessage({ defaultMessage: 'Internal credit rating', id: 'pdp-portfolio-internal-credit-rating' })]);
      }

      if ((0, _ramda.includes)("SHOW_TRADING_CURRENCY_FOR_ALL_HOLDINGS_DOWNLOAD", visibleDataPoints)) {
        labelsForExcel.push(this.props.intl.formatMessage({
          defaultMessage: 'Trading currency',
          id: 'pdp-portfolio-holdings-trading-currency'
        }));
      }

      var holdingType = !(0, _ramda.isNil)(this.props.showWeeklyHoldings) && this.props.showWeeklyHoldings ? 'weeklyHoldings' : 'allHoldings';
      var controller = !(0, _ramda.isNil)(this.props.visibleDataPoints) && (0, _ramda.includes)("DOWNLOAD_HOLDINGS_AS_PDF", this.props.visibleDataPoints) ? "pdf" : "excel";
      var excelServiceURL = encodeURI(this.props.gaiaRedirectUrl + '/' + controller + '?type=' + holdingType + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role + '&date=' + this.getDateToFilterBy() + '&locale=' + _string_utility2.default.generateLocale() + '&headerLabels=') + encodeURIComponent(labelsForExcel);

      return _react2.default.createElement(
        'div',
        { className: 'portfolio-child-card', 'data-testid': 'portfolio-all-holdings-card' },
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: this.props.header,
            headerTitleId: this.props.id,
            breakpoint: this.props.breakpoint,
            headerTitleLabel: "all-holdings-header"
          },
          _react2.default.createElement(
            'div',
            {
              className: 'margin-right-30 padding-bottom-30 ' + (this.props.breakpoint < 2 ? "col-xs-12 col-sm-12" : "width-140 float-left") },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'font-black-variant tag-2 margin-bottom-5', role: 'label', id: 'ReportDate' },
                this.props.intl.formatMessage({ defaultMessage: 'REPORT DATE', id: 'pdp-portfolio-holdings-report-date-label' })
              ),
              this.props.showWeeklyHoldings ? _react2.default.createElement(_readable_field_component.ReadableField, {
                key: 'report-date',
                value: this.getDefaultDateToFilterBy(),
                additionalClassName: 'report-date-selector',
                dataTest: "report-date"
              }) : _react2.default.createElement(
                _click_or_escape_outside2.default,
                { id: 'dropdownReportDates', onClose: this.onClose },
                _react2.default.createElement(_dropdown_component2.default, {
                  dropdownContent: this.getReportDates(),
                  id: 'report-date-selector',
                  className: 'width-130',
                  breakpoint: this.props.breakpoint,
                  initialActiveSelect: this.getDefaultDateToFilterBy(),
                  alwaysOpenOnSelect: false,
                  ariaLabelledby: 'ReportDate',
                  setRefDropdown: function setRefDropdown(node) {
                    return _this7.childRef = node;
                  }
                })
              )
            )
          ),
          this.props.breakpoint > 2 && _react2.default.createElement(
            'div',
            { className: 'width-140 display-inline-block padding-bottom-30 vertical-align-top' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'font-black-variant tag-2 margin-bottom-5', role: 'label', id: 'DisplayRows' },
                this.props.intl.formatMessage({ defaultMessage: 'DISPLAY ROWS', id: 'pdp-portfolio-holdings-display-rows-label' })
              ),
              _react2.default.createElement(
                _click_or_escape_outside2.default,
                { id: 'dropdownRowLabels', onClose: this.onCloseRowDrop },
                _react2.default.createElement(_dropdown_component2.default, {
                  dropdownContent: this.displayRowLabels(),
                  id: 'display-row-selector',
                  className: 'width-120',
                  breakpoint: this.props.breakpoint,
                  initialActiveSelect: selectedRowValue,
                  alwaysOpenOnSelect: false,
                  ariaLabelledby: 'DisplayRows',
                  setRefDropdown: function setRefDropdown(node) {
                    return _this7.childRefRowDrop = node;
                  }
                })
              )
            )
          ),
          _react2.default.createElement(_table_component2.default, {
            tableHeaders: this.renderHeaderRow(labels),
            tableRows: this.renderHoldingsDataRows(),
            tableBodyTest: 'portfolio-all-holdings-body',
            activeTab: this.props.activeTab,
            breakpoint: this.props.breakpoint
          }),
          _react2.default.createElement(
            'div',
            { id: 'holdings-footer' },
            _react2.default.createElement(_button2.default, {
              role: this.props.role,
              dataTest: "holdings-excel-download-link",
              downloadURL: excelServiceURL,
              dataTestLink: this.props.id + '-excel-download',
              text: _string_utility2.default.getLocalizedString(this.props.intl, 'DOWNLOAD ALL HOLDINGS', 'pdp-daily-holdings-download-button'),
              additionalClassName: "mobile-full-width",
              callBack: function callBack() {
                return _tracking_utility.TrackingUtility.trackEvent({
                  "eventCategory": "pdp",
                  "eventAction": "portfolio",
                  "eventLabel": _tracking_utility.TrackingUtility.getEventAction("downloadHoldings")
                });
              }
            }),
            this.displayPagination(this.state.currentPageDisplay, totalNumberOfPages)
          )
        )
      );
    }
  }]);

  return HoldingsCard;
}(_react.Component);

exports.default = (0, _reactIntl.injectIntl)(HoldingsCard, { withRef: true });